/**
 * @generated SignedSource<<b208ac6cd76cb0a2e5921252f1541930>>
 * @relayHash 1991400b2462d0b72d81f1298a73c504
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44ec4e6ec111c9ff866a52aa9f2ebe84dc631f720e8ba2b72b24da9f321b53a5

import type { ConcreteRequest } from 'relay-runtime';
export type ContentReadOnlyMediaSessionQuery$variables = {
  contentId: string;
};
export type ContentReadOnlyMediaSessionQuery$data = {
  readonly contentMediaSession: {
    readonly accessTokens: {
      readonly readOnlyToken: {
        readonly value: string;
      } | null;
    };
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
  } | null;
};
export type ContentReadOnlyMediaSessionQuery = {
  response: ContentReadOnlyMediaSessionQuery$data;
  variables: ContentReadOnlyMediaSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "contentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaAccessTokens",
        "kind": "LinkedField",
        "name": "accessTokens",
        "plural": false,
        "selections": [
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readOnlyToken",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "clientId"
          },
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentReadOnlyMediaSessionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentReadOnlyMediaSessionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1991400b2462d0b72d81f1298a73c504",
    "id": "44ec4e6ec111c9ff866a52aa9f2ebe84dc631f720e8ba2b72b24da9f321b53a5",
    "metadata": {},
    "name": "ContentReadOnlyMediaSessionQuery",
    "operationKind": "query",
    "text": "query ContentReadOnlyMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}},configuration{clientId,fileStoreUrl}}}"
  }
};
})();

(node as any).hash = "a2478aa448d8ba882de605868f454f5f";

export default node;
